import { render, staticRenderFns } from "./EnhancedCouponForm.vue?vue&type=template&id=bff4a588&scoped=true"
import script from "./EnhancedCouponForm.vue?vue&type=script&lang=js"
export * from "./EnhancedCouponForm.vue?vue&type=script&lang=js"
import style0 from "./EnhancedCouponForm.vue?vue&type=style&index=0&id=bff4a588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff4a588",
  null
  
)

export default component.exports